import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "maritime-law.webp",
    title: "Derecho Mercantil",
    crumb: "Derecho Mercantil",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "Servicio integral para la constitución y regularización de empresas venezolanas: desde el documento constitutivo hasta la operatividad legal, fiscal y administrativa.",
  title: "Derecho Mercantil",
  features: {
    title: "Derecho Mercantil",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Constitución de sociedades venezolanas y paquete de servicios mercantiles para poner su empresa en operación conforme a la normativa local.",
    description: `Servicio integral de constitución y regularización mercantil: redactamos el documento constitutivo, elaboramos poderes, gestionamos registros y publicaciones, organizamos inventarios y balances de apertura, abrimos cuentas bancarias, tramitamos el RIF y la inscripción ante organismos como INCES e IVSS. Además ofrecemos redacción y análisis de contratos mercantiles para la actividad operativa de la empresa.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "constitucion",
        title: "Elaboración del documento constitutivo y su registro",
        summary:
          "Redacción personalizada del acta constitutiva/estatutos y gestión completa del registro mercantil hasta la inscripción efectiva.",
        details:
          "Diseñamos el documento constitutivo conforme al tipo societario recomendado (C.A., S.R.L., etc.), estructura accionaria, capital social y reglas de administración. Incluye redacción de estatutos, cláusulas sociales, poderes inherentes y presentación ante el Registro Mercantil competente hasta la obtención de la inscripción.",
        deliverables: [
          "Borrador del documento constitutivo (Word/PDF)",
          "Acta protocolizada y firma notarial (según corresponda)",
          "Comprobante de inscripción registral"
        ],
        requiredDocs: [
          "Datos de socios/accionistas (identificación, RIF si aplica)",
          "Decisión sobre tipo societario y monto de capital",
          "Poderes o autorizaciones si aplican"
        ],
        icon: "fa-solid fa-file-signature",
        image: global.services + "commercial_law/1.webp",
      },
      {
        key: "poderes",
        title: "Elaboración de poderes notariales y corporativos",
        summary:
          "Redacción y protocolización de poderes para representantes legales, apoderados y gestores administrativos.",
        details:
          "Preparamos poderes limitados o generales adaptados a las necesidades operativas (aperturas bancarias, gestión fiscal, trámites registrales). Asesoramos sobre alcance, duración y revocabilidad; coordinamos firma y legalización notarial.",
        deliverables: [
          "Borrador de poder (Word/PDF)",
          "Formato para protocolizar en notaría",
          "Checklist de presentación y validez"
        ],
        requiredDocs: [
          "Identificación de apoderado y poderdante",
          "Datos de la autorización (alcance y límite)",
          "Documentos societarios que lo respalden"
        ],
        icon: "fa-solid fa-pen-fancy",
        image: global.services + "commercial_law/2.webp",
      },
      {
        key: "traduccion",
        title: "Traducción legal y legalización de documentos",
        summary:
          "Traducción certificada de estatutos, poderes y documentos notariales para su uso en Venezuela o en jurisdicciones extranjeras.",
        details:
          "Coordinamos traducciones juradas y su legalización o apostilla (según proceda), garantizando equivalencia jurídica y cumplimiento de requisitos administrativos. Ideal para inversionistas extranjeros y documentos originalmente en otros idiomas.",
        deliverables: [
          "Traducción jurada de documentos",
          "Guía de legalización/apostilla",
          "Documentos listos para registro/entrega"
        ],
        requiredDocs: [
          "Documentos originales a traducir",
          "Instrucciones sobre idioma y formato requerido",
          "Identificación del solicitante"
        ],
        icon: "fa-solid fa-language",
        image: global.services + "commercial_law/3.webp",
      },
      {
        key: "estatus_migratorio",
        title:
          "Ajuste del estatus migratorio de accionistas/representantes extranjeros",
        summary:
          "Asesoría y coordinación para regularizar la situación migratoria de socios o representantes no residentes.",
        details:
          "Asistimos con permisos, visas y documentación necesaria para que accionistas o apoderados extranjeros puedan ejercer funciones societarias y cumplir requisitos administrativos. Coordinamos con despachos migratorios y organismos competentes según el caso.",
        deliverables: [
          "Listado de requisitos migratorios por caso",
          "Tramitación o coordinación con especialistas migratorios",
          "Plantillas y documentos de soporte"
        ],
        requiredDocs: [
          "Pasaporte y documentación personal del extranjero",
          "Documentos societarios que acrediten la relación",
          "Poderes y autorizaciones"
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "commercial_law/4.webp",
      },
      {
        key: "comisario",
        title: "Provisión o asesoría para nombramiento de comisario",
        summary:
          "Asistencia en la designación del comisario mercantil y en las funciones de control y auditoría que le competen.",
        details:
          "Asesoramos sobre la figura del comisario (requisitos, funciones y responsabilidades), proponemos candidatos o ayudamos a contratar el servicio, y preparamos el encargo formal. Facilitamos la relación entre comisario, junta directiva y la contabilidad societaria.",
        deliverables: [
          "Modelo de contrato/encargo del comisario",
          "Guía de funciones y obligaciones",
          "Acta de designación y registro"
        ],
        requiredDocs: [
          "Datos del comisario propuesto",
          "Estatutos sociales y poderes",
          "Documentación contable básica"
        ],
        icon: "fa-solid fa-user-tie",
        image: global.services + "commercial_law/5.webp",
      },
      {
        key: "libros",
        title: "Gestión de libros societarios sellados",
        summary:
          "Tramitamos la legalización y sellado de libros contables y de actas necesarios para la operatividad y cumplimiento legal.",
        details:
          "Preparación y legalización de libros de actas, inventarios, contabilidad y demás registros exigidos; coordinación con Registro Mercantil y notaría para el sellado y registro correspondiente.",
        deliverables: [
          "Libros preparados para legalización",
          "Comprobante de sellado/registro",
          "Instrucciones de uso y custodia"
        ],
        requiredDocs: [
          "Estatutos y actas previas",
          "Identificación de administradores",
          "Poderes si aplican"
        ],
        icon: "fa-solid fa-book",
        image: global.services + "commercial_law/6.webp",
      },
      {
        key: "publicaciones",
        title: "Publicaciones oficiales y avisos legales",
        summary:
          "Gestión de publicaciones en prensa y gaceta según requisitos legales para constitución, reformas y actos societarios.",
        details:
          "Redacción y coordinación de inserciones obligatorias en periódicos o gacetas oficiales; supervisión de plazos legales y obtención de comprobantes de publicación para su incorporación al expediente societario.",
        deliverables: [
          "Boletines/publicaciones realizadas",
          "Comprobante y certificado de publicación",
          "Textos estandarizados para avisos y convocatorias"
        ],
        requiredDocs: [
          "Texto aprobado por la sociedad",
          "Datos de la publicación requerida (fecha, tiraje)",
          "Documentación societaria a publicar"
        ],
        icon: "fa-solid fa-newspaper",
        image: global.services + "commercial_law/7.webp",
      },
      {
        key: "inventario_balance",
        title: "Inventario de bienes y balance de apertura",
        summary:
          "Elaboración del inventario inicial y del balance de apertura requerido para el inicio contable de la sociedad.",
        details:
          "Armamos el inventario de activos y pasivos aportados, evaluamos valores iniciales y preparamos el balance de apertura conforme a normas contables aplicables, incluyendo notas explicativas y soporte documental.",
        deliverables: [
          "Inventario detallado de bienes",
          "Balance de apertura firmado y listo para contabilidad",
          "Notas y documentación de soporte"
        ],
        requiredDocs: [
          "Listas de aportes (bienes, efectivo, valores)",
          "Facturas o títulos de propiedad",
          "Documentación de valuación si aplica"
        ],
        icon: "fa-solid fa-clipboard-list",
        image: global.services + "commercial_law/8.webp",
      },
      {
        key: "apertura_bancaria",
        title: "Apertura de cuenta bancaria empresarial",
        summary:
          "Asistencia en la gestión de requisitos y apertura de cuentas corporativas ante entidades financieras venezolanas.",
        details:
          "Preparamos el expediente bancario requerido, acompañamos la presentación ante la entidad financiera y asesoramos sobre firmas autorizadas, límites operativos y requisitos de compliance KYC/AML.",
        deliverables: [
          "Checklist de requisitos bancarios por entidad",
          "Expediente pre-armado para entrega al banco",
          "Soporte en citas y validaciones"
        ],
        requiredDocs: [
          "Documento constitutivo e inscripción registral",
          "RIF de la sociedad",
          "Poderes de los firmantes y cédulas"
        ],
        icon: "fa-solid fa-university",
        image: global.services + "commercial_law/9.webp",
      },
      {
        key: "rif",
        title: "Emisión del Registro de Información Fiscal (RIF)",
        summary:
          "Trámite y obtención del RIF para la sociedad ante la autoridad tributaria venezolana (SENIAT).",
        details:
          "Gestionamos la inscripción fiscal de la entidad, presentación de documentación requerida ante la administración tributaria y obtención del número de RIF para dar inicio a obligaciones fiscales y facturación.",
        deliverables: [
          "Solicitud presentada ante SENIAT",
          "Comprobante/constancia de RIF",
          "Guía de obligaciones fiscales iniciales"
        ],
        requiredDocs: [
          "Documento constitutivo e inscripción registral",
          "Cédulas/RIF de los representantes",
          "Dirección fiscal y datos de contacto"
        ],
        icon: "fa-solid fa-id-card",
        image: global.services + "commercial_law/10.webp",
      },
      {
        key: "inscripciones",
        title: "Inscripción en INCES, IVSS y organismos públicos",
        summary:
          "Gestión de inscripciones y afiliaciones ante entes laborales y de seguridad social como INCES e IVSS.",
        details:
          "Preparación y presentación de expedientes para la inscripción en organismos públicos requeridos (INCES, IVSS, alcaldías, registros laborales), incluyendo la orientación sobre las obligaciones periódicas y las planillas o formularios a presentar.",
        deliverables: [
          "Expedientes presentados y comprobantes",
          "Guía de cumplimiento de obligaciones periódicas",
          "Registro de patrones y afiliaciones"
        ],
        requiredDocs: [
          "RIF de la empresa",
          "Documento constitutivo e identificación de representantes",
          "Información laboral inicial (nómina estimada)"
        ],
        icon: "fa-solid fa-clipboard-check",
        image: global.services + "commercial_law/11.webp",
      },
      {
        key: "contratos",
        title: "Redacción y análisis de contratos mercantiles",
        summary:
          "Elaboración y revisión de contratos comerciales: servicios, distribución, agencia, suministro y otros acuerdos mercantiles.",
        details:
          "Redactamos contratos mercantiles adaptados a la actividad de la sociedad, revisamos cláusulas de responsabilidad, condiciones de pago, cláusulas penales, garantías, confidencialidad y soluciones de controversias; asesoramos en negociación y mecanismos de ejecución.",
        deliverables: [
          "Borrador de contrato y versión final",
          "Análisis de riesgos contractuales y recomendaciones",
          "Cláusulas opcionales y modelos (NDAs, SLAs, garantías)"
        ],
        requiredDocs: [
          "Antecedentes comerciales y términos negociados",
          "Identificación de las partes y datos fiscales",
          "Documentación técnica o comercial relevante"
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "commercial_law/12.webp",
      }
    ],
  },
  ctaText: "Solicitar asesoría mercantil",
  ctaLink: "/contacto?servicio=derecho-mercantil",
};

